import type { StoreOrderItemMedia } from '@/types'

const UPLOADS_SEGMENT = 'uploads/'

export function extractOrderItemMediaRelativePath(path: string): string | null {
  const trimmed = path.trim()
  if (!trimmed) {
    return null
  }

  const segmentIndex = trimmed.indexOf(UPLOADS_SEGMENT)
  if (segmentIndex >= 0) {
    return trimmed.slice(segmentIndex)
  }

  if (
    !trimmed.startsWith('http://')
    && !trimmed.startsWith('https://')
    && !trimmed.startsWith('blob:')
  ) {
    return trimmed.replace(/^\/+/, '')
  }

  return null
}

export function resolveOrderItemMediaUrl(path?: string | null): string | null {
  if (!path) {
    return null
  }

  const trimmed = path.trim()
  return trimmed || null
}

export function getOrderItemMediaUrlFallback(path?: string | null): string | null {
  if (!path) {
    return null
  }
  return null
}

export function isOrderItemImageMedia(
  media: Pick<StoreOrderItemMedia, 'mime' | 'type' | 'type_str'>,
): boolean {
  if (String(media.mime ?? '').toLowerCase().startsWith('image/')) {
    return true
  }

  if (Number(media.type) === 1) {
    return true
  }

  return String(media.type_str ?? '').toLowerCase().includes('image')
}

export function orderItemMediaFileLabel(media: Pick<StoreOrderItemMedia, 'path' | 'type_str' | 'mime'>): string {
  const resolvedPath = resolveOrderItemMediaUrl(media.path) ?? String(media.path ?? '')
  if (!resolvedPath) {
    return media.type_str ?? media.mime ?? 'Media'
  }

  const lastPart = resolvedPath.split('/').at(-1)
  return (lastPart && lastPart.trim()) || media.type_str || media.mime || 'Media'
}

export function normalizeOrderItemMediaRecord(media: StoreOrderItemMedia): StoreOrderItemMedia {
  const resolvedPath = resolveOrderItemMediaUrl(media.path)
  return {
    ...media,
    path: resolvedPath ?? media.path,
  }
}
